/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { userDonationModelSchema } from "./userDonationModelSchema.ts";
import { z } from "zod";

export const userDonationModelPagedResultSchema = z.object({
    "totalItems": z.number().int(),
"itemsQuantity": z.number().int(),
"itemsOffset": z.number().int(),
"items": z.array(z.lazy(() => userDonationModelSchema))
    })